import { NavLink, Outlet } from 'react-router-dom';
import { Bot, TestTubeDiagonal, MessageSquare, Network, Settings, LogOut } from 'lucide-react';
import { clearApiKey } from '../lib/api';
import { useHealth } from '../hooks/useHealth';

const NAV = [
  { to: '/', icon: Bot, label: 'Agents' },
  { to: '/test', icon: TestTubeDiagonal, label: 'Test' },
  { to: '/sessions', icon: MessageSquare, label: 'Sessions' },
  { to: '/mesh', icon: Network, label: 'Mesh' },
  { to: '/system', icon: Settings, label: 'System' },
] as const;

export function Layout() {
  const { data: health } = useHealth();

  function handleLogout() {
    clearApiKey();
    window.location.reload();
  }

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-surface border-b border-border px-4 h-12 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <span className="text-lg">🏭</span>
          <span className="font-semibold text-sm text-zinc-100">Agent Factory</span>
        </div>
        <div className="flex items-center gap-3">
          {health && (
            <div className="flex items-center gap-1.5 text-xs">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              <span className="text-zinc-400">
                {health.agents} agent{health.agents !== 1 ? 's' : ''}
              </span>
            </div>
          )}
          <button
            onClick={handleLogout}
            className="p-1.5 text-zinc-500 hover:text-zinc-300 transition-colors"
            title="Disconnect"
          >
            <LogOut className="w-3.5 h-3.5" />
          </button>
        </div>
      </header>

      {/* Nav */}
      <nav className="bg-surface border-b border-border flex">
        {NAV.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-4 py-2.5 text-xs font-medium border-b-2 transition-colors ${
                isActive
                  ? 'text-accent-2 border-accent'
                  : 'text-zinc-500 border-transparent hover:text-zinc-300 hover:bg-surface-2'
              }`
            }
          >
            <Icon className="w-3.5 h-3.5" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Content */}
      <main className="flex-1 p-4 md:p-6 max-w-6xl mx-auto w-full">
        <Outlet />
      </main>
    </div>
  );
}
